import React, { useState } from "react";
import classes from "./Toolbar.module.css";
import { withAuthentication } from "../../../hoc/withAuthentication";
import { useLocation } from "react-router-dom";
import withSpinner from "@/hoc/withSpinner";
import Currency from "./Currency";
import Language from "./Language";
import { useEmployeeMode } from "@/components/Employee/useEmployeeCode";
import { getActiveShop } from "@/constants/utility";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import VerifyShop from "./VerifyShop";
import AdminToken from "./AdminToken";
import { icons } from "@/assets/icons/icons";
import ProtectedImage from "@/custom_components/ProtectedImage";

const Toolbar = ({ user, employee }) => {
  const { width } = useWindowDimensions();
  const location = useLocation();
  const shop = getActiveShop(user);
  const isVerifed = shop?.isValidated == "true";
  const [showModal, setShowModal] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  const { signoutEmployee } = useEmployeeMode();
  const name = (employee?.firstName || "") + " " + (employee?.lastName || "");
  return (
    <React.Fragment>
      <header className={[classes.Toolbar].join(" ")}>
        <nav
          className={[
            classes.Height,
            "uk-flex-middle uk-container-expand  uk-navbar menu uk-box-shadow-small uk-light uk-padding-horizontal",
          ].join(" ")}
        >
          <div className="uk-navbar-left">
            <ul className="uk-navbar-nav ">
              <li className="uk-active uk-flex ">
                <a
                  // onClick={navBurgerClickHandler}
                  className="uk-text-bold uk-margin-auto-vertical"
                >
                  <img
                    style={{ height: "50px" }}
                    src={`/icons/header/logo-${user.isRetail ? "retail" : "repair"}.svg`}
                  />
                </a>
              </li>
            </ul>
          </div>
          {window.location.pathname === "/" && width >= 960 && !isVerifed && (
            <div style={{ zIndex: 1 }} className="uk-navbar-center">
              <ul className="uk-navbar-nav">
                <li>
                  <a
                    type="button"
                    className=" uk-text-capitalize uk-text-truncate"
                    // onClick={() => setShowDialog(true)}
                  >
                    <div className="">
                      <span className="uk-text-warp uk-text-small uk-text-bold">
                        Shop not verified, please fill shop verification form.
                      </span>
                    </div>
                    <div className="uk-margin-left">
                      <button
                        onClick={() => setShowModal(true)}
                        className="padding-10 uk-button uk-background-default  color-black uk-text-capitalize uk-text-small uk-text-bold"
                      >
                        Verify Shop
                      </button>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          )}
          {!!user.email && (
            <div className="uk-navbar-right uk-margin-small-right">
              <ul className="uk-navbar-nav">
                {/true/i.test(shop.storemode) ? (
                  <li>
                    <a href="" onClick={signoutEmployee} className=" uk-link-reset" uk-tooltip={"Signout " + name}>
                      <img src="/icons/header/keypad.svg" />
                    </a>
                  </li>
                ) : (
                  <li onClick={() => setShowDialog(true)}>
                    <a>
                      <img className="uk-svg" src="/icons/header/store.svg" />
                    </a>
                  </li>
                )}

                {location.pathname == "/sub" ? (
                  <li>
                    <Language />
                  </li>
                ) : (
                  <li>
                    <Currency />
                  </li>
                )}

                <li>
                  <a>
                    <button type="button" className="icon-button">
                      <span>
                        <ProtectedImage
                          src={shop?.storeLogoImg ? shop?.storeLogoImg : `/icons/header/logo-large.svg`}
                          alt="Store logo"
                          className="uk-svg"
                          width={22}
                        />
                        {/* <img
                          width={22}
                          className="uk-svg"
                          src={shop?.storeLogoImg ? shop?.storeLogoImg : `/icons/header/logo-large.svg`}
                        /> */}
                      </span>
                      {isVerifed ? (
                        <span className="icon-button__badge">
                          <img src="/icons/header/verified.png" />
                        </span>
                      ) : (
                        <span className="icon-button__badge">{icons.warning}</span>
                      )}
                    </button>
                  </a>
                </li>
              </ul>
            </div>
          )}
        </nav>
      </header>
      {showModal && <VerifyShop close={() => setShowModal(false)} />}
      {showDialog && <AdminToken close={() => setShowDialog(false)} />}
      <style jsx>
        {`
          .employee {
            min-height: 80px;
            padding: 0 15px;
            font-size: 0.875rem;
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default withSpinner(withAuthentication(Toolbar));
